// extracted by mini-css-extract-plugin
export default {"notificationContainer":"Notifications_notificationContainer__3EFKj"};